module.exports = __webpack_public_path__ + "media/gifs/lorry-500ab381.gif";